import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromSettings from './settings.reducer';

export const selectSettingsState = createFeatureSelector<fromSettings.State>(
  fromSettings.settingsFeatureKey,
);

export const selectDropboxSettingsState = createSelector(
  selectSettingsState,
  (state) => state?.default?.dropbox,
);

export const selectProjectSettingsState = createSelector(
  selectSettingsState,
  (state) => state?.default?.project,
);

export const selectSettingsLoaded = createSelector(
  selectSettingsState,
  (state) => state.loaded,
);

export const selectSettingsError = createSelector(
  selectSettingsState,
  (state) => state.loadError,
);

export const selectFilterSettings = createSelector(
  selectSettingsState,
  (state) => state.filters,
);

export const selectFilterSettingsShowOnlyCurrent = createSelector(
  selectFilterSettings,
  (state) => state.showOnlyCurrentEmployee,
);
